import { confirmationConstants } from "../../../constants/confirmation/confirmation.constants";
import { alertActions } from "../alert.action";
import { history } from "../../../helpers/history";
import { confirmationService } from "../../../services/confirmation/confirmation.service";


export const confirmationActions = {
  update,
  get,
  getByEvent,
  create,
  createRange,
  deleteConfirmation,
};

function get(confirmationId) {
  return dispatch => {
    dispatch(request({}));
    dispatch(alertActions.clear());
    confirmationService.get(confirmationId).then(
      confirmation => {
        dispatch(success(confirmation));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: confirmationConstants.GET_CONFIRMATION_REQUEST };
  }
  function success(confirmation) {
    return {
      type: confirmationConstants.GET_CONFIRMATION_SUCCESS,
      confirmation
    };
  }
  function failure(error) {
    return {
      type: confirmationConstants.GET_CONFIRMATION_FAILURE,
      error
    };
  }
}

function getByEvent(eventId, includeInherited = false) {
  return dispatch => {
    dispatch(request({}));
    dispatch(alertActions.clear());
    confirmationService.getByEvent(eventId, includeInherited).then(
      confirmationList => {
        dispatch(success(confirmationList));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: confirmationConstants.GET_CONFIRMATION_LIST_REQUEST };
  }
  function success(confirmationList) {
    return {
      type: confirmationConstants.GET_CONFIRMATION_LIST_SUCCESS,
      confirmationList
    };
  }
  function failure(error) {
    return {
      type: confirmationConstants.GET_CONFIRMATION_LIST_FAILURE,
      error
    };
  }
}

function create(confirmation) {
  return dispatch => {
    dispatch(request({}));
    dispatch(alertActions.clear());
    confirmationService.create(confirmation).then(
      confirmation => {
        dispatch(success(confirmation));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: confirmationConstants.CREATE_CONFIRMATION_REQUEST };
  }
  function success(confirmation) {
    return {
      type: confirmationConstants.CREATE_CONFIRMATION_SUCCESS,
      confirmation
    };
  }
  function failure(error) {
    return {
      type: confirmationConstants.CREATE_CONFIRMATION_FAILURE,
      error
    };
  }
}
function createRange(eventId, confirmations) {
  return dispatch => {
    dispatch(request({}));
    dispatch(alertActions.clear());

    confirmationService.createRange(eventId, confirmations).then(
      confirmations => {
        dispatch(success(confirmations));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: confirmationConstants.CREATE_CONFIRMATION_RANGE_REQUEST };
  }
  function success(confirmations) {
    return {
      type: confirmationConstants.CREATE_CONFIRMATION_RANGE_SUCCESS,
      confirmations
    };
  }
  function failure(error) {
    return {
      type: confirmationConstants.CREATE_CONFIRMATION_RANGE_FAILURE,
      error
    };
  }
}
function update(confirmation) {
  return dispatch => {
    dispatch(request({}));
    dispatch(alertActions.clear());
    confirmationService.update(confirmation).then(
      confirmation => {
        dispatch(success(confirmation));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: confirmationConstants.UPDATE_CONFIRMATION_REQUEST };
  }
  function success(confirmation) {
    return {
      type: confirmationConstants.UPDATE_CONFIRMATION_SUCCESS,
      confirmation
    };
  }
  function failure(error) {
    return {
      type: confirmationConstants.UPDATE_CONFIRMATION_FAILURE,
      error
    };
  }
}

function deleteConfirmation(confirmationId) {
  return dispatch => {
    dispatch(request({}));
    dispatch(alertActions.clear());
    confirmationService.deleteConfirmation(confirmationId).then(
      _ => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: confirmationConstants.DELETE_CONFIRMATION_REQUEST };
  }
  function success() {
    return {
      type: confirmationConstants.DELETE_CONFIRMATION_SUCCESS,

    };
  }
  function failure(error) {
    return {
      type: confirmationConstants.DELETE_CONFIRMATION_FAILURE,
      error
    };
  }
}